import { render, staticRenderFns } from "./InstallersService.vue?vue&type=template&id=676c6d88&scoped=true"
import script from "./InstallersService.vue?vue&type=script&lang=js"
export * from "./InstallersService.vue?vue&type=script&lang=js"
import style0 from "./InstallersService.vue?vue&type=style&index=0&id=676c6d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c6d88",
  null
  
)

export default component.exports